export default "<!-- loading --> <div ng-show=vm.appLoading id=appLoading> <div class=page-splash> <div class=page-splash-message ng-bind=vm.loadingMessage> </div> <div class=loading> <div><i class=\"fa fa-refresh fa-spin fa-5x\"></i></div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loader/loader.tpl.html
// module id = 446
// module chunks = 0